import { atom } from "recoil";

const showArchivedCandidates = atom<boolean>({
  key: "ShowArchivedCandidates",
  default: false,
});

export default showArchivedCandidates;
